import { pageDocumentToMarkdown, pageExportFilename } from '@couplespace/core/blocks';

import { fetchPageDocument } from './api';

export async function buildPageMarkdown(pageId: string): Promise<string> {
  const document = await fetchPageDocument(pageId);
  const title = document.block.title?.trim() || 'Untitled';
  return pageDocumentToMarkdown(title, pageId, document.contentBlocks);
}

export async function copyPageAsMarkdown(pageId: string): Promise<void> {
  const markdown = await buildPageMarkdown(pageId);
  if (!navigator.clipboard?.writeText) {
    throw new Error('Clipboard is not available in this browser');
  }
  await navigator.clipboard.writeText(markdown);
}

export async function downloadPageAsMarkdown(pageId: string): Promise<void> {
  const pageDocument = await fetchPageDocument(pageId);
  const title = pageDocument.block.title?.trim() || 'Untitled';
  const markdown = pageDocumentToMarkdown(title, pageId, pageDocument.contentBlocks);
  const blob = new Blob([markdown], { type: 'text/markdown;charset=utf-8' });
  const url = URL.createObjectURL(blob);
  const anchor = window.document.createElement('a');
  anchor.href = url;
  anchor.download = pageExportFilename(title);
  anchor.click();
  URL.revokeObjectURL(url);
}
